"use strict";

var get = require('../getValueOfKeyMatching');

function WeddingMenus(params) {
  var quantity = get(params, /menus/);
  var acc_ribbon = get(params, /acc_ribbon/);
  this.personalization.push({
    name: 'Names and Date',
    value: get(params, /menu_namedate/)
  });
  this.personalization.push({
    name: 'Menu Wording',
    value: get(params, /wording/)
  });
  this.weddingMenus.add({
    quantity: quantity,
    acc_ribbon: acc_ribbon
  });
}

module.exports = WeddingMenus;